module.exports = __webpack_public_path__ + "0b3e187817c5b13fca776d3835d72c97.woff2";